'use strict'

# What this module exports
module.exports =
	filters:
		serialport: require('./serialport')
